import * as React from 'react';
import type { SVGProps } from 'react';
const SvgIncidentsFull = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    viewBox="0 0 30 30"
    {...props}
  >
    <path
      fill="var(--color-surface-interactive-secondary-hover)"
      d="M0 8a8 8 0 0 1 8-8h14a8 8 0 0 1 8 8v14a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
    />
    <path
      fill="var(--color-content-base-secondary)"
      d="M14.833 22.384c.05.675-.516 1.242-1.152 1.011-1.555-.566-3.931-1.997-3.931-5.468.289-2.078 1.251-3.675 1.795-5.659.216-.79.305-1.167.518-3.457 0-.974.837-1.91 1.887-1.384 1.417.708 1.718 2.74 2.1 5.25.3 1.963.744 2.316 1.204.55.048-.315.125-.633.125-.959 0-1.33 1.507-1.163 1.985-.334 2.733 4.735 3.02 9.778-1.642 11.487-.568.208-1.06-.216-1.005-.818.117-1.276.18-3.101-.93-3.101-.98 0-1.045 1.642-.954 2.882"
    />
  </svg>
);
export default SvgIncidentsFull;
